import React from 'react';
interface ChipProps {
  label: string;
  selected: boolean;
  onClick: () => void;
  className?: string;
}
export function Chip({
  label,
  selected,
  onClick,
  className = ''
}: ChipProps) {
  return <button type="button" onClick={onClick} className={`
        px-4 py-2 rounded-full text-sm font-bold transition-all duration-200
        focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2
        ${selected ? 'bg-emerald-500 text-white shadow-md scale-105' : 'bg-white border-2 border-slate-100 text-slate-600 hover:border-slate-200 hover:bg-slate-50'}
        ${className}
      `} data-id="element-85">
      {label}
    </button>;
}